import { useTranslation } from 'react-i18next';
import { getTranslation, fetchCorrectTranslation } from '../../utils/translation';

function Partners({ theme = 'basic' }) {
  const { t } = useTranslation();

  const isTR2026 = theme === 'tr2026';

  // tr_2026 keys live at root — bypass getTranslation (which prepends teamType),
  // but still resolve the { ch, default } variant object via fetchCorrectTranslation
  const get = (subKey) => {
    if (isTR2026) {
      const raw = t(`tr_2026.partner.${subKey}`, { returnObjects: true });
      return fetchCorrectTranslation(raw);
    }
    return getTranslation(t, `landing.partner.${subKey}`);
  };

  return (
    <div className="flex flex-col items-center justify-center font-extrabold text-xl md:text-4xl">
      {/* <h2 className="text-center">{get('title')}</h2> */}
      <img className="w-96 md:w-[33%] md:max-w-[600px]" src={get('image')} alt="" />
    </div>
  );
}

export default Partners;
